import React, { createContext, useContext } from 'react';
import { connect } from "react-redux";

import { useGeolocation } from './useGeolocation';

export const GeolocationContext = createContext();

// custom hook to access geolocation context
export const useGeolocationContext = () => useContext(GeolocationContext);

export const GeolocationProvider = ({ children, userSession }) => {
	// useGeolocation hook as the value/store of the context provider
	const geolocationStore = useGeolocation(userSession);

	return (
		<GeolocationContext.Provider value={geolocationStore}>
			{children}
		</GeolocationContext.Provider>
	);
};

const mapStateToProps = store => ({
    userSession: store.userSession
})

export default connect(mapStateToProps)(GeolocationProvider)